export const PREDEFINED_METRICS_FALLBACK = [
  {
    key: "confidence",
    label: "Confidence",
    description: "Clarity, assertiveness, and presentation quality evident in the CV",
    type: "predefined",
  },
  {
    key: "language_proficiency",
    label: "Language proficiency",
    description: "Written language quality and stated language skills",
    type: "predefined",
  },
  {
    key: "role_match",
    label: "Role match",
    description: "How closely past roles and trajectory match this job",
    type: "predefined",
  },
  {
    key: "role_proficiency",
    label: "Role proficiency",
    description: "Depth of relevant skills and domain competence",
    type: "predefined",
  },
  {
    key: "experience",
    label: "Experience",
    description: "Years, seniority, and relevance of work history",
    type: "predefined",
  },
]

export const batchStatusLabel = (status) => {
  const map = {
    DRAFT: "Draft",
    UPLOADING: "Uploading",
    QUEUED: "Queued",
    PROCESSING: "Analyzing",
    COMPLETED: "Completed",
    FAILED: "Failed",
    PARTIAL: "Partial",
  }
  return map[status] || status || "Unknown"
}

export const batchStatusClass = (status) => {
  const map = {
    DRAFT: "bg-slate-100 text-slate-700",
    UPLOADING: "bg-sky-100 text-sky-800",
    QUEUED: "bg-amber-100 text-amber-800",
    PROCESSING: "bg-cyan-100 text-cyan-800",
    COMPLETED: "bg-emerald-100 text-emerald-800",
    FAILED: "bg-red-100 text-red-800",
    PARTIAL: "bg-orange-100 text-orange-800",
  }
  return map[status] || "bg-gray-100 text-gray-700"
}

export const recommendationLabel = (rec) => {
  const map = {
    STRONG_FIT: "Strong fit",
    POSSIBLE_FIT: "Possible fit",
    WEAK_FIT: "Weak fit",
  }
  return map[rec] || "—"
}

export const recommendationClass = (rec) => {
  const map = {
    STRONG_FIT: "bg-emerald-100 text-emerald-800",
    POSSIBLE_FIT: "bg-amber-100 text-amber-800",
    WEAK_FIT: "bg-slate-100 text-slate-600",
  }
  return map[rec] || "bg-gray-100 text-gray-600"
}

export const itemStatusLabel = (status) => {
  const map = {
    PENDING: "Pending",
    EXTRACTING: "Reading CV",
    ANALYZING: "Analyzing",
    DONE: "Done",
    FAILED: "Failed",
  }
  return map[status] || status || "—"
}

export const formatScore = (score) =>
  typeof score === "number" && Number.isFinite(score) ? Math.round(score) : "—"

export const scoreBarColor = (score) => {
  if (typeof score !== "number") return "bg-gray-200"
  if (score >= 75) return "bg-emerald-500"
  if (score >= 50) return "bg-amber-400"
  return "bg-slate-400"
}

export const equalWeights = (count) => (count > 0 ? 1 / count : 0)

export const normalizeMetricWeights = (metrics) => {
  const sum = metrics.reduce((s, m) => s + (Number(m.weight) || 0), 0)
  if (sum <= 0) {
    const w = equalWeights(metrics.length)
    return metrics.map((m) => ({ ...m, weight: w }))
  }
  return metrics.map((m) => ({ ...m, weight: (Number(m.weight) || 0) / sum }))
}

export const apiErrorMessage = (res, fallback = "Something went wrong") =>
  res?.result?.data?.data || res?.result?.data?.message || fallback
